export default __webpack_public_path__ + "static/media/dropdownicon_down.6aeb1e89.png";